import * as React from 'react';
import { SVGProps } from 'react';
const Error = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 36 32"
		fill="none"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M18 13v6.25M2.495 24.877c-1.443 2.5.362 5.623 3.247 5.623h24.516c2.884 0 4.689-3.123 3.247-5.623L21.248 3.63c-1.443-2.5-5.053-2.5-6.496 0L2.495 24.877ZM18 24.25h.012v.013H18v-.013Z"
		/>
	</svg>
);
export default Error;
